import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { ANALYTICS_DATE_RANGES } from "../../../constants/buyerAnalyticsConstants";
import { TRIAL_READINESS_LABELS, formatPercent } from "../../../constants/automapDealerPerformanceConstants";
import { fetchAdminDealerAnalytics } from "../../../services/automapDealerPerformanceApi";
import { AdminAnalyticsNav, AnalyticsRangeSelect } from "./AdminAnalyticsShared";
import { AdminMarketplaceAnalyticsNav } from "./marketplace/AdminMarketplaceAnalyticsShared";

export default function AdminDealerAnalyticsPage() {
  const [range, setRange] = useState("last_30_days");
  const [city, setCity] = useState("");
  const [needsFollowUp, setNeedsFollowUp] = useState(false);
  const [foundingOnly, setFoundingOnly] = useState(false);
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    const params = { range };
    if (city.trim()) params.city = city.trim();
    if (needsFollowUp) params.needsFollowUp = "true";
    if (foundingOnly) params.foundingOnly = "true";
    fetchAdminDealerAnalytics(params)
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar analytics."))
      .finally(() => setLoading(false));
  }, [range, city, needsFollowUp, foundingOnly]);

  return (
    <AdminPageLayout>
      <AdminPageHeader
        eyebrow="AutoMapa · Analytics"
        title="Analytics de concesionarios"
        description="Comparación de rendimiento, trials y calidad de inventario."
      />
      <AdminAutomotiveNav active="analytics" />
      <AdminAnalyticsNav active="dealers" />
      <AdminMarketplaceAnalyticsNav active="dealers" />
      <main className="admin-console__main wrap">
        <div className="dealer-inventory-toolbar">
          <AnalyticsRangeSelect range={range} onChange={setRange} options={ANALYTICS_DATE_RANGES} />
          <input placeholder="Ciudad" value={city} onChange={(e) => setCity(e.target.value)} />
          <label>
            <input type="checkbox" checked={needsFollowUp} onChange={(e) => setNeedsFollowUp(e.target.checked)} />
            Necesita seguimiento
          </label>
          <label>
            <input type="checkbox" checked={foundingOnly} onChange={(e) => setFoundingOnly(e.target.checked)} />
            Solo fundadores
          </label>
        </div>
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading && !error ? (
          <section className="dealer-state-box">
            <table className="dealer-inventory-table">
              <thead>
                <tr>
                  <th>Concesionario</th>
                  <th>Ciudad</th>
                  <th>Trial</th>
                  <th>Activos</th>
                  <th>Vistas</th>
                  <th>WhatsApp</th>
                  <th>Leads</th>
                  <th>Calificados</th>
                  <th>Conv.</th>
                  <th>Frescura</th>
                  <th>Calidad</th>
                  <th>Trial ready</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {(payload.dealers || []).map((row) => (
                  <tr key={row.dealerId}>
                    <td>{row.dealerName}</td>
                    <td>{row.city || "—"}</td>
                    <td>{row.trialStatus || "—"}</td>
                    <td>{row.activeListings}</td>
                    <td>{row.views}</td>
                    <td>{row.whatsappClicks}</td>
                    <td>{row.leads}</td>
                    <td>{row.qualifiedLeads}</td>
                    <td>{formatPercent(row.leadConversionRate)}</td>
                    <td>{formatPercent(row.inventoryFreshness)}</td>
                    <td>{row.averageQualityScore ?? "—"}</td>
                    <td>{TRIAL_READINESS_LABELS[row.trialReadiness] || row.trialReadiness}</td>
                    <td>
                      <Link to={`/admin/dealers/${row.dealerId}/performance`}>Ver</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
